function initSmoothScrollAnimation() {
	// Smooth scroll to
	$('.scroll-animation').on('click', function (e) {
		e.preventDefault();

		const href = $(this).attr('href');
		if (href) {
			$("html, body").animate({
				scrollTop: $(href).offset().top
			}, 1000);
		}
	});

	$('.scroll-animation a').on('click', function (e) {
		e.stopPropagation();
	});
}
